import { collection, getDocs, query, where } from 'firebase/firestore'

import { firestore } from '../../firebase/firebaseConfig'

export const getPracticeDatesByDateRange = async (
  userId: string,
  startDate: string,
  endDate: string,
) => {
  const logsReference = collection(firestore, 'students', userId, 'logs')
  const periodQuery = query(
    logsReference,
    where('date', '>=', startDate),
    where('date', '<=', endDate),
  )
  const snapshot = await getDocs(periodQuery)

  return snapshot.docs
    .map((document) => document.data().date)
    .filter((date): date is string => typeof date === 'string')
}
